
export enum RevalidationItemType {
  Unknown = 0,
  Planned = 1,
  Unplanned = 2,
  PeerDiscussion = 3,
  ReflectiveAccount = 4
}
